import { Gender } from './enums';

/** Mars / Venus symbols via escapes so file encoding cannot corrupt them. */
export const GENDER_ICON_MALE = '\u2642';
export const GENDER_ICON_FEMALE = '\u2640';
export const MULTIPLY_SIGN = '\u00d7';
export const BULLET = '\u2022';
export const WARNING_EMOJI = '\u26A0\uFE0F';

export function getGenderIcon(gender: Gender | string | null | undefined): string {
  switch (gender) {
    case Gender.MALE:
    case 'MALE':
      return GENDER_ICON_MALE;
    case Gender.FEMALE:
    case 'FEMALE':
      return GENDER_ICON_FEMALE;
    default:
      return '?';
  }
}

export function getGenderAvatarClass(gender: Gender | string | null | undefined): string {
  switch (gender) {
    case Gender.MALE:
    case 'MALE':
      return 'text-cyan-600 border-blue-300';
    case Gender.FEMALE:
    case 'FEMALE':
      return 'text-pink-600 border-pink-300';
    default:
      return 'text-slate-600 border-gray-300';
  }
}

export function getGenderBorderClass(gender: Gender | string | null | undefined): string {
  switch (gender) {
    case Gender.MALE:
    case 'MALE':
      return 'border-blue-300';
    case Gender.FEMALE:
    case 'FEMALE':
      return 'border-pink-300';
    default:
      return 'border-gray-300';
  }
}

export function getGenderColorClass(gender: Gender | string | null | undefined): string {
  switch (gender) {
    case Gender.MALE:
    case 'MALE':
      return 'text-cyan-600';
    case Gender.FEMALE:
    case 'FEMALE':
      return 'text-pink-600';
    default:
      return 'text-slate-600';
  }
}
